module.exports = __webpack_public_path__ + "static/img/BMWi_Fz_2017_Office_Farbe_de.52ca1b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/BMWi_Fz_2017_Office_Farbe_de.png
// module id = 6lLG
// module chunks = 1